<template>
  <a-layout>
    <drawer v-if="isMobile" :openDrawer="collapsed" @change="onDrawerChange">
      <sider-menu :theme="theme" :menuData="systemAuths" :collapsed="false" :collapsible="false" @menuSelect="onMenuSelect"/>
    </drawer>
<!--菜单-->
    <sider-menu class="sidebar-container"
                :theme="theme"
                v-else-if="layout === 'side'"
                :menuData="systemAuths"
                :collapsed="collapsed"
                :collapsible="true"
                @systemMenuClick="systemMenuClick">
    </sider-menu>
    <a-layout>
      <global-header v-if="isMobile" :menuData="systemAuths" :collapsed="collapsed" @toggleCollapse="toggleCollapse"/>
<!--      头部-->
      <global-header v-if="!isMobile"
                     :class="collapsed == true ? 'left80': 'left256'"
                     :menuData="systemAuths"
                     :collapsed="collapsed"
                     @toggleCollapse="toggleCollapse"/>

      <a-layout-content v-if="isMobile" style="margin-top: 24px;margin-left: 24px;margin-right: 24px">
        <slot></slot>
      </a-layout-content>

<!--      内容-->
      <a-layout-content v-if="!isMobile && collapsed" :style="{minHeight: minHeight, margin: '20px 20px 0 104px'}">
        <slot></slot>
      </a-layout-content>
      <a-layout-content v-if="!isMobile && !collapsed" :style="{minHeight: minHeight, margin: '20px 20px 0 280px'}">
        <slot></slot>
      </a-layout-content>

<!--      底部-->
      <a-layout-footer v-if="!isMobile" style="margin-top: 5px">
        <global-footer :link-list="linkList" style="margin-left: 256px" :copyright="copyright" />
      </a-layout-footer>
      <a-layout-footer v-if="isMobile" style="margin-top: 5px">
        <global-footer :link-list="linkList" :copyright="copyright" />
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import GlobalHeader from './GlobalHeader'
import GlobalFooter from './GlobalFooter'
import Drawer from '../components/tool/Drawer'
import SiderMenu from '../components/menu/SiderMenu'
import Setting from '../components/setting/Setting'
const minHeight = window.innerHeight - 64 - 24 - 122
let menuData = []
export default {
  name: 'GlobalLayout',
  components: {Setting, SiderMenu, Drawer, GlobalFooter, GlobalHeader},
  data () {
    return {
      minHeight: minHeight + 'px',
      collapsed: false,
      menuData: menuData
    }
  },
  computed: {
    systemAuths () {
      if (this.$store.state.user.systemAuths.length <= 0) {
        return this.$router.options.routes.find((item) => item.path === '/').children
      }
      return this.$store.state.user.systemAuths.find((item) => item.path === '/').children
    },
    isMobile () {
      return this.$store.state.setting.isMobile
    },
    theme () {
      return this.$store.state.setting.theme
    },
    layout () {
      return this.$store.state.setting.layout
    },
    linkList () {
      return this.$store.state.setting.footerLinks
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    onDrawerChange (show) {
      this.collapsed = show
    },
    onMenuSelect (obj) {
      this.toggleCollapse()
    },
    systemMenuClick (menu) {
      if (menu.meta && menu.meta.isSystem) {
        // 防止用户网络慢的情况，第一次点击后到下一次点击前不可点击
        let clickMenu = this.$store.state.user.clickMenu
        if (clickMenu !== menu.meta.authKey) {
          localStorage.setItem('clickSystemMenu', JSON.stringify(menu.meta))
          this.$store.dispatch('fillChildMenuOnSystemClick', menu.meta)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  // 侧边栏
  .sidebar-container {
    height: 100%;
    overflow: auto;
    position: fixed;
    font-size: 0px;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
  }
  .left256{
    margin-left: 256px;
  }
  .left80{
    margin-left: 80px;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/GlobalLayout.vue